import React from 'react';
import styles from './index.css';
const raf = require('raf');
class Tab extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleTouchStart = (e) => {
            const touch = e.touches[0];
            this.startX = touch.pageX;
            this.moveX = 0;
            this.leftFlag = true;
            this.rightFlag = true;
        };
        this.handleTouchMove = (e) => {
            const { initLeft, left, maxMove } = this.state;
            const touch = e.touches[0];
            let move = 0;
            if (this.moveX >= 0 && left <= 0) {
                if (this.leftFlag) {
                    this.initLeftMove = left;
                    this.startLeftX = touch.pageX;
                    this.leftFlag = false;
                }
                this.moveX = touch.pageX - this.startLeftX;
                move = this.initLeftMove - this.moveX / 3;
            }
            else if (this.moveX <= 0 && left >= maxMove) {
                if (this.rightFlag) {
                    this.initRightMove = left;
                    this.startRightX = touch.pageX;
                    this.rightFlag = false;
                }
                this.moveX = touch.pageX - this.startRightX;
                move = this.initRightMove - this.moveX / 3;
            }
            else {
                this.moveX = touch.pageX - this.startX;
                move = initLeft - this.moveX;
            }
            this.setState({
                left: move,
            });
        };
        this.handleTouchEnd = () => {
            const { left, maxMove } = this.state;
            if (left < 0) {
                raf(this.backStep);
            }
            else if (left > maxMove) {
                raf(this.backStep);
            }
            else {
                this.setState({
                    initLeft: left,
                });
            }
        };
        // 回弹
        this.backStep = () => {
            const { initLeft, maxMove } = this.state;
            let { left } = this.state;
            if (left < initLeft) {
                left += 10;
            }
            else if (left > initLeft) {
                left -= 10;
            }
            this.setState({
                left,
            });
            if (this.moveX >= 0 && left >= 0) {
                this.setState({
                    left: 0,
                    initLeft: 0,
                });
            }
            else if (this.moveX <= 0 && left <= maxMove) {
                this.setState({
                    left: maxMove,
                    initLeft: maxMove,
                });
            }
            else {
                raf(this.backStep);
            }
        };
        this.setLocation = (translateX) => {
            return 'WebKitCSSMatrix' in window
                ? `translate3d(${translateX * -1}px, 0, 0)`
                : `translate(-${translateX * -1}px, 0)`;
        };
        this.navsRef = React.createRef();
    }
    componentDidMount() {
        this.navScroll();
    }
    // 判断选中位置并修改位移z
    navScroll() {
        try {
            const { current } = this.navsRef; // 当前需要计算的
            const target = document.querySelector(`.${styles.current}`); // 被选中
            if (current && target) {
                const parent = current.parentElement; // 父元素（滚动条）
                const parentWidth = (parent && parent.getBoundingClientRect().width) || 0; // 父元素宽度
                const element = target.parentElement; // 子元素
                const elementLeft = (element && element.getBoundingClientRect().left) || 0; // 子元素位移
                if (elementLeft >= parentWidth && current.parentElement)
                    current.parentElement.scroll(elementLeft - 10, 0); // 滚动
            }
        }
        catch (err) {
            /* err */
            console.error(err);
        }
    }
    render() {
        const { content, currentPath } = this.props;
        return (React.createElement("ul", { ref: this.navsRef, className: styles.tabs }, content.map((item, index) => (React.createElement("li", { key: index },
            React.createElement("a", { className: currentPath === item.searchPath ? styles.current : styles.item, href: item.url }, item.title),
            currentPath === item.searchPath ? (React.createElement("div", { className: styles.dot },
                React.createElement("span", null))) : (''))))));
    }
}
export default Tab;
